import {
    FETCH_INITIAL_TEMPLATES_DATA_REQUEST,
    FETCH_INITIAL_TEMPLATES_DATA_SUCCESS,
    FETCH_INITIAL_TEMPLATES_DATA_FAILURE,
  } from "./FetchInitialTemplateDataTypes";
  
  const initialState = {
    loading: false,
    initialTemplatesData: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_INITIAL_TEMPLATES_DATA_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_INITIAL_TEMPLATES_DATA_SUCCESS:
        return {
          loading: false,
          initialTemplatesData: action.payload,
          error: "",
        };
      case FETCH_INITIAL_TEMPLATES_DATA_FAILURE:
        return {
          loading: false,
          initialTemplatesData: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  